module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showScreeningOption) ? _c('table', {
    staticClass: "table-confirmation"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.hasScreening && _vm.showScreeningOption && _vm.canBeApproved) ? _c('tr', [_c('td', [_c('el-form', {
    ref: "formPaper",
    attrs: {
      "model": _vm.paper,
      "label-width": "20%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Observações"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5
    },
    model: {
      value: (_vm.paper.notes),
      callback: function($$v) {
        _vm.$set(_vm.paper, "notes", $$v)
      },
      expression: "paper.notes"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.isSubmitted
    },
    on: {
      "click": _vm.onAcceptPaper
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('span', [_vm._v("Aprovado")])]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": _vm.isSubmitted || _vm.$v.paper.$invalid
    },
    on: {
      "click": _vm.onRejectPaper
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _vm._v(" "), _c('span', [_vm._v("Reprovado")])]), _vm._v(" "), _c('span', {
    staticClass: "helper-text"
  }, [_vm._v("Para reprovar o trabalho você precisa fornecer uma resposta ao autor")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.showScreeningOption) ? _c('tr', [_c('td', [(_vm.isInvoiceOpened) ? _c('el-alert', {
    attrs: {
      "title": "Trabalho aguardando liberação",
      "type": "error",
      "description": "Pagamento da inscrição do autor não confirmado.",
      "closable": false,
      "show-icon": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isInvoicePaid && _vm.isEditDaysAvailable) ? _c('el-alert', {
    attrs: {
      "title": "Trabalho aguardando liberação",
      "type": "error",
      "description": "O trabalho ainda está no período de edição.",
      "closable": false,
      "show-icon": ""
    }
  }) : _vm._e()], 1)]) : _vm._e()])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Liberação do Trabalho")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-98d24e5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/event/components/show/paper/Screening.vue
// module id = 778
// module chunks = 2